(function () {

  function updateVariantAvailability() {

    document.querySelectorAll('.m-product-card').forEach(function (card) {

      const jsonElement = card.querySelector(
        'script[type="application/json"]'
      );

      if (!jsonElement) return;

      let variants;

      try {
        variants = JSON.parse(jsonElement.textContent);
      } catch (error) {
        return;
      }

      if (!Array.isArray(variants)) return;

      card.querySelectorAll(
        '.m-product-option--node__label[data-value]'
      ).forEach(function (swatch) {

        const swatchValue = swatch.dataset.value;
        if (!swatchValue) return;

        const variant = variants.find(function (item) {
          return item && item.title === swatchValue;
        });

        if (!variant) return;

        swatch.classList.toggle(
          'greatest-variant-sold-out',
          variant.available === false
        );

      });

    });

  }


  // Prevent multiple rapid executions while Horizon
  // is rebuilding the collection.
  let updateTimer;

  function scheduleUpdate() {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      updateVariantAvailability();
    }, 100);
  }


  function init() {

    // Initial page load
    updateVariantAvailability();


    // Horizon's collection/filter component
    const resultsList =
      document.querySelector('results-list');

    if (resultsList) {

      const observer = new MutationObserver(function () {
        scheduleUpdate();
      });

      observer.observe(resultsList, {
        childList: true,
        subtree: true
      });

    } else {

      // Fallback in case the theme structure changes
      const observer = new MutationObserver(function () {
        scheduleUpdate();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

    }


    // Extra fallback for Horizon filter interactions
    document.addEventListener('change', function (event) {

      if (
        event.target.closest('facets-form-component') ||
        event.target.closest('.facets')
      ) {

        // Give Horizon time to finish replacing the products
        setTimeout(updateVariantAvailability, 300);
        setTimeout(updateVariantAvailability, 700);

      }

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();